<template>
    <div class="page">
        <my-scroll scroll-state ref="myScroll" :page="page" :on-pull="onPull">
            <div slot="scrollList">
                <div class="public-head index-head">
                    <div style="height:0.5rem">
                        <div>
                          <img class="public-img" src="../assets/image/Profile/profile-icon.png">
                          <label class="profile-name">alfred24 point</label>
                        </div>
                        <label style="color: transparent;">alfred24 point</label>
                        <div class="open-width">
                          <button class="public-head-language" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true"
                            style="
                              display: flex;
                              min-width: 100px;
                              align-items: center;
                              justify-content: space-between;
                              padding-left: 15px;
                              padding-right: 15px;
                              text-wrap: nowrap;
                            "
                          >
                              <p>{{languageName}}</p>
                              <span class="caret open-width-caret"></span>
                          </button>
                          <ul class="dropdown-menu public-head-language-menu" aria-labelledby="dropdownMenu1">
                            <li v-for="list in languages" @click="choiceLanguage($event)" v-bind:data-langcode="list.langcode" v-bind:key="list.langcode">
                              <a href="javascript:void(0);">{{list.name}}</a>
                            </li>
                          </ul>
                        </div>
                    </div>
                    <div>
                        <span class="iconfont icon-home3" @click="goHome"></span>
                        <p class="Profile-p">
                            <span>{{language === '繁體中文' ? locationName : locationNameEn}}</span>
                        </p>
                    </div>
                    <div class="index-selece-code">
                        <div class="index-selece">
                            <img src="../assets/image/index/123.png">
                            <input id="seleceInput" type="text" :value="search" @keyup.enter="keywordSearch($event)">
                            <div class="input-tag-box">
                                <div class="input-tag" :class="cate + '-tag'" v-if="cate">
                                    <span>
                                        {{$t(cate)}}
                                    </span>
                                    <span class="close-tag" @click="closeStatus($event)">x</span>
                                </div>
                                <div class="input-tag tag-exp" v-if="cate==='Stored'">
                                    <span>
                                        {{$t('Exp')}}
                                    </span>
                                    <span class="close-tag" @click="closeStatus($event)">x</span>
                                </div>
                            </div>
                        </div>
                        <img v-on:click="barcode()" src="../assets/image/index/Component 3 – 3.png">
                    </div>
                </div>
                <div class="index-body">
                    <div class="index-body-list block">
                        <div class="Cannotfind" v-if="emptyList">{{$t('searchResult.CannotFind')}}</div>
                        <div class="index-body-list1 block">
                            <div class="index-body-baikuang" @click="detail(item)" v-for="item in searchList" :style="{height:item.timeStored ? itemHeight : '0.65rem'}">
                                <p class="index-body-baikuang-p1">
                                    <span v-if="item.displayStatus==='Stored' || item.displayStatus==='Returns'">{{$t('searchResult.TimeStored')}}: {{item.timeStored ? dateFormat(item.timeStored) : null}}<br></span>
                                    <span v-if="item.displayStatus==='Collected' && item.timeCollected">{{$t('searchResult.TimeCollected')}}: {{item.timeCollected ? dateFormat(item.timeCollected) : null}}<br></span>
                                    <span v-if="item.displayStatus==='ExpiredReturned' || item.displayStatus==='Returned'">{{$t('searchResult.TimeReturned')}}: {{item.timeCollected ? dateFormat(item.timeCollected) : null}}<br></span>
                                    <span>
                                       {{item.displayMerchantName}}
                                    </span>
                                </p>
                                <p class="index-body-baikuang-p2">{{item.trakingNumber}}</p>
                                <!-- <div class="index-body-div" :style="{'margin-top':item.timeStored ? tagHeight : '-0.4rem'}"> -->
                                <div class="index-body-div" :style="{'margin-top': '-0.4rem'}">
                                    <div class="order-status" :class="item.displayStatus"
                                         @click.stop="detail(item)">
                                        {{$t(item.displayStatus)}}
                                    </div>
                                    <div class="Unstored" @click.stop="detail(item)" v-if="item.unstoredFlag">
                                        {{$t('Unstored')}}
                                    </div>
                                    <div class="exp" @click.stop="detail(item)" v-if="item.overdueFlag && item.displayStatus === 'Stored'">
                                        {{$t('Exp')}}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </my-scroll>

        <!-- <router-link to="/index">
            <button class="index-body-home block">{{$t('common.Home')}}</button>
        </router-link>
        <bottom></bottom> -->
        <div class="home_bt">
          <button class="home_bt_w" @click="$router.back()">{{$t('common.Home')}}</button>
        </div>
        <bottom></bottom>
    </div>
</template>

<script>
import bottom from './Bottom.vue'
import MyScroll from './MyScroll'

export default {
  name: 'SearchResult',
  components: {bottom, MyScroll},
  data () {
    return {
      // languages: [
      //   {name: 'English'},
      //   {name: '繁體中文'}
      // ],
      languages: window.config.VUE_APP_LANG_LIST.split(';').map(x => {
        return {
          name: x.split(':')[0],
          langcode: x.split(':')[1]
        }
      }),
      language: 'en',
      languageName: 'English',
      itemHeight: '0.75rem',
      tagHeight: '-0.57rem',
      searchList: [],
      emptyList: true,
      cate: null,
      search: null,
      tag: null,
      locationName: localStorage.getItem('locationName'),
      locationNameEn: localStorage.getItem('locationNameEn'),
      params: null,
      page: {
        total: 0
      }
    }
  },
  created () {
    let lang = localStorage.getItem('lang')
    // if (lang === 'zh_HK') {
    //   this.language = '繁體中文'
    // } else if (lang) {
    //   this.language = lang
    // }
    let _lang = window.config.VUE_APP_LANG_LIST.split(';').map(x => {
      return {
        name: x.split(':')[0],
        langcode: x.split(':')[1]
      }
    }).find(x => x.langcode === lang)
    this.language = _lang.langcode
    this.languageName = _lang.name
    // 获取路由query参数
    let route = this.$route
    this.search = route.query.search ? route.query.search : null
    this.cate = route.query.cate ? route.query.cate : null
    // 获取查询数据
    this.params = {
      query: this.search,
      status: this.cate,
      page: 0,
      size: 20,
      sort: 'lastUpdatedTime,desc'
    }

    this.getData()
  },
  methods: {
    goHome () {
      this.$router.push('/')
    },
    choiceLanguage (e) {
      this.languageName = e.currentTarget.firstElementChild.innerText
      this.language = e.currentTarget.getAttribute('data-langcode')
      let lang = this.language
      this.$i18n.locale = lang
      // if (lang === '繁體中文') {
      //   lang = 'zh_HK'
      //   this.$i18n.locale = 'zh'
      // } else if (lang === 'English') {
      //   this.$i18n.locale = 'en'
      // } else {
      //   this.$i18n.locale = 'en'
      // }
      localStorage.setItem('lang', lang)
    },
    barcode () {
      this.$router.push('/barcode?action=parcelInfo')
    },
    getData (append = true) {
      const vue = this
      console.log(this.params.status)
      if (this.params.status === 'Collected') {
        vue.params.dateType = 'day'
      } else {
        vue.params.dateType = null
      }
      let tmpQuery = '?status=' + vue.params.status + '&page=' + vue.params.page + '&size=' + vue.params.size + '&sort=' + vue.params.sort
      if (vue.cate === 'Stored') {
        tmpQuery += '&sort=overdueFlag,asc'
      }
      if (vue.params.query) {
        tmpQuery += '&query=' + vue.params.query
      }
      if (vue.params.dateType) {
        tmpQuery += '&dateType=' + 'day'
      }
      this.axios({
        method: 'get',
        url: this.api.queryOrders + tmpQuery
        // params: vue.params
      }).then(function (response) {
        // vue.searchList = response.data.content
        if (!append) {
          vue.searchList = []
        }
        vue.pushList(response.data.content)
        vue.page.total = response.data.totalPages
        if (vue.searchList.length < 1) {
          vue.emptyList = true
        }
      }).catch(function (error) {
        // console.log(error)
      })
    },
    pushList (data = null) {
      for (let i = 0; i < data.length; i++) {
        if (data[i]['displayStatus'] === 'Expired returned') {
          data[i]['displayStatus'] = 'ExpiredReturned'
        }
        this.searchList.push(data[i])
      }
    },
    onPull () { // 加载回调
      const vue = this

      if (this.params.page < this.page.total) {
        setTimeout(() => {
          vue.params.page++
          // 加载完成
          this.$refs.myScroll.setState(5)
          console.log('onPull getData')
          vue.getData()
        }, 500)
      } else {
        // 没有数据了
        this.$refs.myScroll.setState(7)
      }
    },
    closeTag (e) {
      this.tag = null
      this.getData()
    },
    closeStatus (e) {
      this.params.page = 0
      this.searchList = []
      this.cate = null
      this.params.status = null
      this.getData()
    },
    keywordSearch (e) {
      this.params.page = 0
      this.search = e.srcElement.value
      this.params.query = e.srcElement.value
      this.getData(false)
    },
    detail (item) {
      let id = item.articleId
      this.$router.push('/order/details?order=' + id)
    },
    dateFormat (time) {
      // let monthArr = new Array('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Spt', 'Oct', 'Nov', 'Dec')
      let monthArr = this.$t('common.monthArr')
      time = new Date(time)
      let m = monthArr[time.getMonth()] + this.$t('common.space')
      let d = time.getDate() + this.$t('common.dayFormat')
      let h = time.getHours()
      if (h.toString().length === 1) {
        h = '0' + h
      }
      let mm = time.getMinutes()
      if (mm.toString().length === 1) {
        mm = '0' + mm
      }
      let dateStr = m + d + ', ' + h + ':' + mm
      return dateStr
    },
    changeTag (tag) {
      this.tag = tag
      // this.getData()
    },
    changeStatus (status) {
      return false
      this.searchList = []
      this.cate = status
      this.params.status = status
      this.getData()
    }
  },
  watch: {
    searchList: function (obj) {
      if (obj.length > 0) {
        this.emptyList = false
      }
    }
  }
}
</script>
<style src="../assets/css/bootstrap.css" scoped></style>
<style scoped>
    .order-status {
        padding: 0 0.13rem;
        background: rgba(0, 172, 78, 0.5);
        border-radius: 0.1rem;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        font-size: 0.125rem;
    }

    .input-tag-box {
        position: relative;
        top: -0.19rem;
        left: 0.27rem;
        width: 2.7rem;
    }

    .input-tag {
        height: 0.2rem;
        display: inline-block;
        background: #1f8dc5;
        line-height: 0.13rem;
        border-radius: 0.03rem;
        padding: 0.03rem;
        font-family: 'Poppins-Regular';
        font-size: 0.125rem;
        color: white;
        font-weight: normal;
    }

    .close-tag {
        padding-left: 0.05rem;
        position: relative;
        right: 0.02rem;
        font-size: 0.15rem;
    }

    .Arriving-tag {
        background: rgba(5, 36, 96, 0.5);
    }

    .Stored-tag {
        background: rgba(31, 141, 197, 0.5);
    }

    .Collected-tag {
        background: rgba(0, 172, 78, 0.5);
    }

    .Returns-tag {
        background: rgba(178, 70, 154, 0.5);
    }

    .Created-tag {
        background: #E2A148;
    }

    .Returned-tag {
        background: rgba(0, 172, 78, 0.5);
    }

    .Arriving {
        background: rgba(5, 36, 96, 0.5);
    }

    .Stored {
        background: rgba(31, 141, 197, 0.5);
        font-family: 'Poppins-Regular';
    }

    .Collected {
        background: rgba(0, 172, 78, 0.5);
    }

    .Returns {
        background: rgba(178, 70, 154, 0.5);
    }

    .Created {
        padding: 0 0.13rem;
        background: rgba(226,161,72,0.5);
        border-radius: 0.1rem;
        color: rgba(255, 255, 255, 1);
        text-align: center;
    }

    .Returned {
        padding: 0 0.13rem;
        background: rgba(0, 172, 78, 0.5);
        border-radius: 0.1rem;
        color: rgba(255, 255, 255, 1);
        text-align: center;
    }
    .Expired.returned{
        background:rgba(172,172,172,0.5);
    }
    .ExpiredReturned{
        background:rgba(172,172,172,0.5);
    }
    .Cannotfind {
        margin-top: 2.535rem;
        width: 100%;
        text-align: center;
        font-size: 0.15rem !important;
        font-weight: 400;
        font-family: 'Poppins-Regular';
        line-height: 0.18rem !important;
        color: rgba(172, 172, 172, 1) !important;
    }

    .index-body-div .Unstored {
        margin-right: 0.02rem;
    }

    .index-body-div .exp {
        margin-right: 0.02rem;
    }

    .index-body-baikuang {
        width: 93.33%;
        height: 0.75rem;
        margin: auto;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 0.1rem rgba(0, 0, 0, 0.16);
        border-radius: 0.1rem;
        margin-top: 0.11rem !important;
        padding-left: 6.14%;
        padding-top: 0.135rem;
        text-align: left;
    }

    .index-body-baikuang-p1 {
        font-size: 0.125rem;
        font-weight: 400;
        font-family: 'Poppins-Regular';
        line-height: 0.15rem;
        color: rgba(172, 172, 172, 1);
        position: relative;
        top: -0.06rem;
    }

    .index-body-baikuang-p1-none {
        font-size: 0.125rem;
        font-weight: 400;
        font-family: 'Poppins-Regular';
        line-height: 0.15rem;
        color: rgba(172, 172, 172, 1);
        display: none;
    }

    .index-body-baikuang-p1-none {
        font-size: 0.125rem;
        font-weight: 400;
        font-family: 'Poppins-Regular';
        line-height: 0.15rem;
        color: rgba(172, 172, 172, 1);
        display: none;
    }

    .index-body-baikuang-p2 {
        font-family: 'Poppins-Regular';
        font-size: 0.15rem;
        font-weight: 400;
        line-height: 0.18rem;
        color: rgba(0, 0, 0, 1);
        /*margin-top: 0.04rem;*/
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .Unstored {
        padding: 0 0.09rem;
        background: rgba(255, 255, 255, 0.5);
        border: 0.005rem solid rgba(247, 148, 29, 1);
        color: rgba(247, 148, 29, 1);
        text-align: center;
        border-radius: 0.1rem;
        font-size: 0.125rem;
    }

    .exp {
        padding: 0 0.09rem;
        background: rgba(255, 255, 255, 0.5);
        border: 0.005rem solid rgba(255, 0, 0, 1);
        color: rgba(255, 0, 0, 1);
        text-align: center;
        border-radius: 0.1rem;
        font-size: 0.125rem;
    }

    .tag-exp {
        background: rgba(255, 255, 255, 0.5);
        color: rgba(255, 0, 0, 1);
        border: 1px solid rgba(255, 0, 0, 1);
    }

    .tag-Expired {
        color: rgba(255, 0, 0, 1);
        background: rgba(255, 255, 255, 0.5);
        border: 0.005rem solid rgba(255, 0, 0, 1);
    }

    .tag-unstored {
        color: rgba(247, 148, 29, 1);
        background: rgba(255, 255, 255, 0.5);
        border: 0.005rem solid rgba(247, 148, 29, 1);
    }
    .bottom{
        margin-top: 1rem !important;
    }
    .index-body-list{
        min-height: calc(40vh) !important;
    }
    .index-body-list1{
        min-height: calc(40vh) !important;
    }
    .index-body-list{
        overflow: unset;
    }
    .index-body-list1{
        overflow: unset;
    }
    .index-body-div{
        margin-top: -0.57rem;
    }
    .index-body-baikuang-p1 span{
        display: block;
        margin-top: 0.03rem;
    }
</style>
<style lang="less" scoped>

  .page {
    .home_bt {
      position: fixed;
      width: 82%;
      // left: 9%;
      bottom: 0.4rem;
      z-index: 999;
      max-width: 400px;
      left: 50%;
      transform: translateX(-50%);
      .home_bt_w {
        width: 100%;
        height: 0.58rem;
        // background: rgba(255, 255, 255, 1);
        background: var(--primary-inverted-button-bg-color);
        box-shadow: 0rem 0.05rem 0.1rem rgba(0, 0, 0, 0.16);
        opacity: 1;
        border-radius: 0.42rem;
        border: none;
        // color: rgba(5, 36, 96, 1);
        color: var(--primary-inverted-button-text-color);
        line-height: 0.235rem;
        font-size: 0.2rem;
        /*font-weight: bold;*/
        font-family: Poppins-Bold;
      }
      .home_bt_b {
        margin-top: 0.1rem;
        width: 100%;
        height: 0.58rem;
        // background: linear-gradient(113deg, rgba(5, 36, 96, 1) 0%, rgba(31, 157, 197, 1) 100%);
        // background: linear-gradient(to right, #191E96 , #00BEF5 );
        background: linear-gradient(to right, #01BAFF , #01BAFF );
        box-shadow: 0rem 0.05rem 0.1rem rgba(5, 36, 96, 0.3);
        border-radius: 0.42rem;
        border: none;
        color: #ffffff;
        line-height: 0.235rem;
        font-size: 0.2rem;
        /*font-weight: bold;*/
        font-family: Poppins-Bold;
      }
    }
    .bottom {
      position: fixed;
      bottom: 0.06rem;
      max-width: 400px;
      max-width: 400px;
      left: 50%;
      -webkit-transform: translateX(-50%);
      transform: translateX(-50%);
    }
  }
  .loading-container{
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--primary-label-color);
    padding: 10px;
    cursor: pointer;
    gap: 10px;
    font-size: 18px;
  }
  .loading-spinner {
    -webkit-animation:spin 1.5s linear infinite;
    -moz-animation:spin 1.5s linear infinite;
    animation:spin 1.5s linear infinite;
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchResult.vue